export const toURLFriendlyString = (inputString) => {
    // Replace spaces with empty strings and convert to lowercase
    const urlFriendlyString = inputString.replace(/\s+/g, '')
    return urlFriendlyString;
  }
